package one.healthium.today.di

import one.healthium.tasks.di.dailyTasksModule
import one.healthium.today.ui.fodmap.TodayViewModel
import org.koin.core.module.dsl.viewModelOf
import org.koin.dsl.module

val todayUiFodmapModule = module {
    includes(dailyTasksModule)
    viewModelOf(::TodayViewModel)
}